import React from "react";

const About = () => {
  return (
    <div>
      <h2 className="text-center text-success fw-bold mt-3 mb-5">My About Page</h2>
    </div>
  );
};

export default About;
